export interface AppMenuItem {
  key: string
  labelKey: string
  path: string
  icon?: string
}

export interface AppMenuGroup {
  id: string
  labelKey: string
  defaultOpen?: boolean
  children: AppMenuItem[]
}

/** 对齐 risk-platform-demo.html 菜单分组；未实现页面保留占位或映射现有路由 */
export const APP_MENU_GROUPS: AppMenuGroup[] = [
  {
    id: 'architecture',
    labelKey: 'menuGroup.architecture',
    defaultOpen: true,
    children: [
      { key: 'system-architecture', labelKey: 'menu.systemArchitecture', path: '/system-architecture', icon: 'ApartmentOutlined' },
    ],
  },
  {
    id: 'access',
    labelKey: 'menuGroup.access',
    defaultOpen: true,
    children: [
      { key: 'scenes', labelKey: 'menu.scenes', path: '/scenes', icon: 'AppstoreOutlined' },
      { key: 'scene-dicts', labelKey: 'menu.sceneDicts', path: '/scene-dicts', icon: 'BookOutlined' },
      { key: 'access-points', labelKey: 'menu.accessPoints', path: '/access-points', icon: 'ApiOutlined' },
    ],
  },
  {
    id: 'feature',
    labelKey: 'menuGroup.featurePlatform',
    defaultOpen: true,
    children: [
      { key: 'features', labelKey: 'menu.features', path: '/features', icon: 'DatabaseOutlined' },
      { key: 'feature-rates', labelKey: 'menu.featureRates', path: '/feature-rates', icon: 'ThunderboltOutlined' },
    ],
  },
  {
    id: 'rule',
    labelKey: 'menuGroup.ruleCenter',
    defaultOpen: true,
    children: [
      { key: 'rules', labelKey: 'menu.rules', path: '/rules', icon: 'ControlOutlined' },
      { key: 'merchant-thresholds', labelKey: 'menu.merchantThresholds', path: '/merchant-thresholds', icon: 'ShopOutlined' },
      { key: 'merchant-rules', labelKey: 'menu.merchantRules', path: '/merchant-rules', icon: 'SolutionOutlined' },
    ],
  },
  {
    id: 'decision',
    labelKey: 'menuGroup.decision',
    defaultOpen: true,
    children: [
      { key: 'strategies', labelKey: 'menu.strategies', path: '/strategies', icon: 'DeploymentUnitOutlined' },
      { key: 'decision-trees', labelKey: 'menu.decisionTrees', path: '/decision-trees', icon: 'PartitionOutlined' },
    ],
  },
  {
    id: 'audit',
    labelKey: 'menuGroup.audit',
    defaultOpen: false,
    children: [
      { key: 'decision-publish', labelKey: 'menu.decisionPublish', path: '/decision-publish', icon: 'AuditOutlined' },
    ],
  },
  {
    id: 'verify',
    labelKey: 'menuGroup.verify',
    defaultOpen: false,
    children: [
      { key: 'verify-trace-single', labelKey: 'menu.verifyTraceSingle', path: '/verify/trace-single', icon: 'SearchOutlined' },
      { key: 'verify-execution-instances', labelKey: 'menu.verifyExecutionInstances', path: '/verify/execution-instances', icon: 'ProfileOutlined' },
      { key: 'verify-conclusions', labelKey: 'menu.verifyConclusions', path: '/verify/conclusions', icon: 'FileSearchOutlined' },
      { key: 'verify-simulate', labelKey: 'menu.verifySimulate', path: '/verify/simulate', icon: 'ExperimentOutlined' },
      { key: 'verify-lineage', labelKey: 'menu.verifyLineage', path: '/verify/lineage', icon: 'NodeIndexOutlined' },
      { key: 'verify-trace-batch', labelKey: 'menu.verifyTraceBatch', path: '/verify/trace-batch', icon: 'ClusterOutlined' },
      { key: 'verify-velocity-read', labelKey: 'menu.verifyVelocityRead', path: '/verify/velocity-read', icon: 'ReadOutlined' },
      { key: 'verify-velocity-write', labelKey: 'menu.verifyVelocityWrite', path: '/verify/velocity-write', icon: 'EditOutlined' },
    ],
  },
  {
    id: 'system',
    labelKey: 'menuGroup.system',
    defaultOpen: false,
    children: [
      { key: 'home', labelKey: 'menu.home', path: '/home', icon: 'SettingOutlined' },
    ],
  },
]

/** menu key → AppMenuItem 映射，用于 tab 标题等查找 */
export const ROUTE_MENU_MAP: Record<string, AppMenuItem> = Object.fromEntries(
  APP_MENU_GROUPS.flatMap(group => group.children.map(item => [item.key, item]))
)
